module.exports = __webpack_public_path__ + "static/media/mp.c5dbb4a6.png";